import { ICellRendererParams } from 'ag-grid-community';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProgressStatusBar } from 'components/molecules/projects/progress-status';

export const ProgressPercentCellRenderer: FC<ICellRendererParams> = ({
  data,
}) => {
  return (
    <ProgressStatusBar
      progressStatuses={data.progressStatus}
      subTitle={data.projectName}
      title={<FormattedMessage id="projects.list.progress" />}
    />
  );
};
